// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlSubDomainSegment = /(?:[a-z0-9](?:[a-z0-9_\-]*[a-z0-9])?)/i;
export default validateUrlSubDomainSegment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twitter-text/dist/esm/regexp/validateUrlSubDomainSegment.js
// module id = 425
// module chunks = 110